define([
	"dojo/_base/declare",
	"csi/access/crews",
	"csi/action/New",
	"csi/def",
	"csi/state/rootStore"
], function(declare,crews,New,def,{ routerStore }) {

	return declare(New, {
		validate: function(/*Context*/ctx) {
			// summary: don't show action is user does not have proper access
			if (!this.inherited(arguments)) return false;

			const product = routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Material");

			return product &&
				!product.Hidden &&
				def.canNavigateToType("SupplierRequest") &&
				crews.isInGlobalRoles(["Supplier Request Administrator","Supplier Request Editor"]);
		}
	});
});